import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';

import PhotoCreate from './create';
import PhotoList from './list';
import PhotoShow from './show';
import PhotoEdit from './edit';

export default {
    create: PhotoCreate,
    list: PhotoList,
    show: PhotoShow,
    edit: PhotoEdit,
    icon: PhotoLibraryIcon
};